import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

const List = styled.ul`
  list-style-type: none;
  margin-block-start: 0;
  border-top: 3px solid lightgrey;
  padding-inline-start: 0;
`
const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  height: 3rem;
  line-height: 3rem;
  border-bottom: 3px solid lightgrey;
  padding-inline-start: 1em;
  text-align: left;
`
const ListItemText = styled.div`
  display: inline-block;
  flex: 1;
  overflow: hidden;
`
const Icon = styled.div`
  flex: none;
  background-color: white;
  width: 3rem;
  height: 100%;
  padding-left: 0.7rem;
  /*padding-top: 0rem;*/
  /*line-height: 2rem;*/
`

export default function ResultsList({ items, onItemClick }) {
  //console.warn('rendering ResultsList');
  return (
    <List>
      {items.map((item, i) => {
        //console.log('item ' + i);
        return (
            <ListItem key={item.text + i} onClick={onItemClick} >
              <ListItemText>{item.text}</ListItemText>
              <Icon>
                <FontAwesomeIcon
                  icon={faArrowCircleRight}
                  size="lg"
                  color="grey"
                  style={{pointerEvents: "none"}}
                />
              </Icon>
            </ListItem>
        )
      })}
    </List>
  )
}
